import { AuthSessionInfoSpec, FeedbackConfig, HttpRoutes, RepositorySpec } from '../..';
import { HttpResponse } from '../../mazars-network-http-client';
import { FeedbackConfigSpec } from './model/FeedbackConfig';
import { Repository } from '../../Repository';
import { OrganizationParams } from '../../../types/types';

export interface FeedbackRepositorySpec extends RepositorySpec {
    /// Fetch the feedback Config of the given organization, there is one config per organization
    fetch(params: OrganizationParams, sessionInfo: AuthSessionInfoSpec): Promise<FeedbackConfig | null>;

    create(feedbackConfig: FeedbackConfigSpec, sessionInfo: AuthSessionInfoSpec): Promise<string[]>;

    update(feedbackConfig: FeedbackConfigSpec, sessionInfo: AuthSessionInfoSpec): Promise<string[]>;

    delete(ids: string[], sessionInfo: AuthSessionInfoSpec): Promise<string[]>;
}

export class FeedbackRepository extends Repository implements FeedbackRepositorySpec {
    async fetch(params: OrganizationParams, sessionInfo: AuthSessionInfoSpec): Promise<FeedbackConfig | null> {
        const parameters = { ...params };
        const response = (await this.datasource.remote.get(
            HttpRoutes.FeedbackConfigs,
            sessionInfo.accessToken,
            undefined,
            parameters,
            this.refreshAccessToken(sessionInfo)
        )) as HttpResponse<FeedbackConfig, any>;

        return response.data || null;
    }

    async create(feedbackConfig: FeedbackConfigSpec, sessionInfo: AuthSessionInfoSpec): Promise<string[]> {
        const response = (await this.datasource.remote.post(
            HttpRoutes.FeedbackConfigs,
            feedbackConfig,
            sessionInfo.accessToken,
            undefined,
            this.refreshAccessToken(sessionInfo)
        )) as HttpResponse<string[], any>;

        return response.data || [];
    }

    async update(feedbackConfig: FeedbackConfigSpec, sessionInfo: AuthSessionInfoSpec): Promise<string[]> {
        const response = (await this.datasource.remote.put(
            HttpRoutes.FeedbackConfigs,
            feedbackConfig,
            sessionInfo.accessToken,
            undefined,
            this.refreshAccessToken(sessionInfo)
        )) as HttpResponse<string[], any>;

        return response.data || [];
    }

    async delete(ids: string[], sessionInfo: AuthSessionInfoSpec): Promise<string[]> {
        const response = (await this.datasource.remote.delete(
            HttpRoutes.FeedbackConfigs,
            ids,
            sessionInfo.accessToken,
            undefined,
            this.refreshAccessToken(sessionInfo)
        )) as HttpResponse<string[], any>;

        return response.data || [];
    }
}
